import guidedTourSlice from '.';

/** @deprecated Migration-only — do not drive tour UI from this slice. */
export const { clearLegacyGuidedTour } = guidedTourSlice.actions; // eslint-disable-line import/prefer-default-export
